<template>
  <div id="app">
    <div class="background-card" ></div>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import Vue from 'vue';
import CONSTANTS from './store/constants'

export default {
  name: "app",
  created() {
    Vue.mixin({
      created: function() {
        this.CONSTANTS = CONSTANTS;
      }
    });
  }
};
</script>